import React from 'react';
import './Trust.css';

// Import relevant icons for the feature cards
import { FaShieldAlt, FaSearchDollar, FaExclamationTriangle, FaGlobe } from 'react-icons/fa';

// Data for the four feature cards
const trustData = [
  {
    icon: <FaShieldAlt />,
    title: 'Protect your margins',
    description: 'Confident pricing saves money, protects profits, and eliminates costly mistakes.'
  },
  {
    icon: <FaSearchDollar />,
    title: 'Benchmark with confidence',
    description: 'Skip the time and cost of discovering prices on your own. Use ours — verified, credible, and timely.'
  },
  {
    icon: <FaExclamationTriangle />,
    title: 'Mitigate market risks',
    description: 'We remove the grey zones. Our processes ensure the prices you see are real, not reactions.'
  },
  {
    icon: <FaGlobe />,
    title: 'Compliant with global benchmarks',
    description: 'We blend international best practices with deep on-ground intelligence — giving you the best of both worlds.'
  }
];

const Trust = () => {
  return (
    <section className="trust-section">
      <div className="trust-container">
        <div className="section-header">
          <h2>Why businesses trust CRISHI prices</h2>
          <div className="header-line"></div>
        </div>

        <div className="trust-grid">
          {trustData.map((item, index) => (
            <div key={index} className="trust-card">
              <div className="trust-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>

        <div className="final-cta">
          <h4>Ready to see how it works?</h4>
          <p>
            Whether you’re negotiating a contract, closing a deal, or auditing procurement - CRISHI's price indices give you the clarity, confidence, and control to move forward.
          </p>
          <div className="cta-button-group">
            <button className="cta-button primary">Use our price indices</button>
            <button className="cta-button secondary">Become a price submitter</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Trust;